// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsInvoice__wrapper__2PS3z","returnModalLink":"DetailsInvoice__returnModalLink__86H7i","title":"DetailsInvoice__title__2CAIb","tooltipContainer":"DetailsInvoice__tooltipContainer__XQjQu"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/DetailsInvoice.scss
// module id = 1717
// module chunks = 4 14